module.exports = __webpack_public_path__ + "static/media/bottom-left-couple.743a3e94.jpeg";